<div class="app-music-player-wrapper" *ngIf="musicService.isStateSuccess()">
  <app-music-toolbar class="hide-on-med-and-up"></app-music-toolbar>
  <div class="app-music-content-wrapper">
    <div class="app-music-content">
      <app-music-header></app-music-header>
      <app-music-playlist></app-music-playlist>
    </div>
  </div>
  <app-music-controls></app-music-controls>
</div>